<div id="scene_text_wrap" class="scene_text_{{practiceIndex}}">

</div>



// WEBPACK FOOTER //
// ./src/app/scene-text/scene-text.component.html